import { ACTION_TYPES, CUSTOM_CONSTANTS } from "Constants";
import _ from "lodash";

const initialState = {
  siteNewLogo: localStorage.getItem("siteLogo") || null,
};

const SiteSettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SITE_LOGO: {
      if (!_.isEmpty(action?.payload)) {
        localStorage.setItem("siteLogo", action.payload);
      }
      return {
        ...state,
        siteNewLogo: action.payload,
      };
    }
    default:
      return state;
  }
};

export default SiteSettingsReducer;
